"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _themeUi = require("theme-ui");

var _Obfuscator = _interopRequireDefault(require("../Obfuscator/Obfuscator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Drawer = function Drawer(_ref) {
  var position = _ref.position,
      children = _ref.children,
      visible = _ref.visible,
      onClickOutside = _ref.onClickOutside,
      props = _objectWithoutPropertiesLoose(_ref, ["position", "children", "visible", "onClickOutside"]);

  return (0, _themeUi.jsx)(_Obfuscator["default"], {
    sx: {
      position: 'fixed',
      zIndex: 5,
      opacity: visible ? 1 : 0,
      visibility: visible ? 'visible' : 'hidden',
      transition: function transition(theme) {
        return visible ? "visibility 300ms " + theme.easing.quickToSlow + ", opacity 300ms " + theme.easing.quickToSlow : "visibility 300ms " + theme.easing.slowToQuick + ", opacity 300ms " + theme.easing.slowToQuick;
      }
    }
  }, (0, _themeUi.jsx)(_themeUi.Flex, _extends({}, props, {
    onClick: onClickOutside,
    sx: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      width: '100%',
      justifyContent: position === 'left' ? 'flex-start' : 'flex-end',
      pl: position === 'left' ? 0 : 5,
      pr: position === 'right' ? 0 : 5,
      transform: visible ? 'translateX(0)' : position === 'left' ? 'translateX(-115%)' : 'translateX(115%)',
      transition: function transition(theme) {
        return visible ? "transform 300ms " + theme.easing.quickToSlow : "transform 300ms " + theme.easing.slowToQuick;
      }
    }
  }), (0, _themeUi.jsx)(_themeUi.Flex, {
    sx: {
      minHeight: '100vh'
    }
  }, _react["default"].Children.only(_react["default"].cloneElement(children, {
    freeze: !visible,
    onClick: function onClick(event) {
      return event.stopPropagation();
    }
  })))));
};

Drawer.propTypes = {
  onClickOutside: _propTypes["default"].func,
  children: _propTypes["default"].node.isRequired,
  position: _propTypes["default"].oneOf(['left', 'right']),
  visible: _propTypes["default"].bool
};
Drawer.defaultProps = {
  onClickOutside: null,
  position: 'left',
  visible: false
};
var _default = Drawer;
exports["default"] = _default;